/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ConvexSiloWrapperMagician,
  ConvexSiloWrapperMagicianInterface,
} from "../ConvexSiloWrapperMagician";

const _abi = [
  {
    inputs: [],
    name: "InvalidAsset",
    type: "error",
  },
  {
    inputs: [],
    name: "Unsupported",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b5061020a806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c806321ebbf011461003b5780636ea477da14610071575b600080fd5b61004e610049366004610184565b610084565b604080516001600160a01b03909316835260208301919091520160405180910390f35b61004e61007f366004610184565b610150565b600080836001600160a01b0316632495a5996040518163ffffffff1660e01b8152600401602060405180830381865afa1580156100c5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906100e991906101b0565b604051630e5a77ed60e21b8152600481018590529092508391506001600160a01b03851690633969dfb490602401600060405180830381600087803b15801561013157600080fd5b505af1158015610145573d6000803e3d6000fd5b505050509250929050565b600080604051634851657960e11b815260040160405180910390fd5b6001600160a01b038116811461018157600080fd5b50565b6000806040838503121561019757600080fd5b82356101a28161016c565b946020939093013593505050565b6000602082840312156101c257600080fd5b81516101cd8161016c565b939250505056fea2646970667358221220009f48c59b1496835743cbaad6de9dd2ecda996fa4572f1a6425d28e44d343ee64736f6c634300080d0033";

type ConvexSiloWrapperMagicianConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ConvexSiloWrapperMagicianConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ConvexSiloWrapperMagician__factory extends ContractFactory {
  constructor(...args: ConvexSiloWrapperMagicianConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ConvexSiloWrapperMagician";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ConvexSiloWrapperMagician> {
    return super.deploy(overrides || {}) as Promise<ConvexSiloWrapperMagician>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ConvexSiloWrapperMagician {
    return super.attach(address) as ConvexSiloWrapperMagician;
  }
  connect(signer: Signer): ConvexSiloWrapperMagician__factory {
    return super.connect(signer) as ConvexSiloWrapperMagician__factory;
  }
  static readonly contractName: "ConvexSiloWrapperMagician";
  public readonly contractName: "ConvexSiloWrapperMagician";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ConvexSiloWrapperMagicianInterface {
    return new utils.Interface(_abi) as ConvexSiloWrapperMagicianInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ConvexSiloWrapperMagician {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ConvexSiloWrapperMagician;
  }
}
